import { render, staticRenderFns } from "./appstore.vue?vue&type=template&id=13d984cd&"
import script from "./appstore.vue?vue&type=script&lang=ts&"
export * from "./appstore.vue?vue&type=script&lang=ts&"
import style0 from "./appstore.vue?vue&type=style&index=0&id=13d984cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports